(function() {
    angular
        .module("dashboard")
        .controller(
            "OrderUpConnectingRtapiModalController",
            [
                "$scope",
                "$uibModalInstance",
                OrderUpConnectingRtapiModalController
            ]
        );

    function OrderUpConnectingRtapiModalController(
        $scope,
        $uibModalInstance,
    ) {}
})();
